import { mapGetters } from 'vuex';

const SignIn = {
	name: 'SignIn',
	template: `
		<div class="sign-in" v-if="show" v-click-outside="closeWindow">
			<slot
				:show="show"
				:forgotPassword="forgotPassword"
				:showForgotPassword="showForgotPassword"
				:forgotPasswordSuccess="forgotPasswordSuccess"
				:hasSignInError="hasSignInError"
				:hasForgotPasswordError="hasForgotPasswordError"
				:closeWindow="closeWindow"
				:submitSignIn="submitSignIn"
				:submitForgotPassword="submitForgotPassword"
				:toggle="toggle"
			></slot>
		</div>
	`,
	methods: {
		closeWindow: function() {
			this.$store.dispatch('signin/show', false);
		},
		toggle: function() {
			this.$store.dispatch('signin/toggle');
		},
		forgotPassword: function() {
			this.$store.dispatch('signin/forgotPassword', true);
		},
		submitSignIn: function(event) {
			this.$store.dispatch('signin/submitSignIn', event.target);
		},
		submitForgotPassword: function(event) {
			this.$store.dispatch('signin/submitForgotPassword', event.target);
		},
	},
	computed: {
		...mapGetters({
			show: 'signin/show',
			showForgotPassword: 'signin/showForgotPassword',
			forgotPasswordSuccess: 'signin/forgotPasswordSuccess',
			hasSignInError: 'signin/hasSignInError',
			hasForgotPasswordError: 'signin/hasForgotPasswordError',
		})
	}
};

export default SignIn;



// WEBPACK FOOTER //
// ../shared/components/sign-in/index.js